<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoContainer fluid>
      <SoRow>
        <SoCol>
          <ActivityFeedWidget />
        </SoCol>
      </SoRow>
    </SoContainer>
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoContainer from "@/components/SoContainer.vue"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import ActivityFeedWidget from "./widgets/ActivityFeedWidget.vue"

  export default defineComponent({
    components: {
      SoContainer,
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoRow,
      SoCol,
      ActivityFeedWidget,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
  })
</script>
